<!--
  - Copyright Huesik (c) 2019.
  - 필터 기능 공통 레이아웃입니다.
  -->

<template>
  <div class="filter" :style="{'padding-top': paddingY, 'padding-bottom': paddingY, width}" :class="classes">
    <div class="filter-header" :style="{'padding-left' : paddingX, 'padding-right': paddingX}">
      <h5>{{title}}</h5>
      <span :style="subTitleStyle" class="subtitle">{{subTitle}}</span>
    </div>
    <div class="filter-contents" :style="{'padding-left' : paddingX, 'padding-right': paddingX}">
      <slot></slot>
    </div>
    <!--<div class="filter-footer">-->
      <!--<button>취소하기</button>-->
      <!--<button>적용하기</button>-->
    <!--</div>-->
  </div>
</template>

<script>
  export default {
    name: 'FilterLayout',
    props: {
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      subTitleStyle: {
        type: Object,
        default: () => {}
      },
      paddingX: {
        type: String,
        default: '1rem'
      },
      paddingY: {
        type: String,
        default: '1rem'
      },
      width: {
        type: String,
        default: '29rem'
      },
      classes: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="less">
  .filter {
    position:absolute;
    top: 8.1rem;
    color: black;
    background-color: white;
    z-index: 2;
    border: 1px solid #cccccc;
    border-top: 0;

    .filter-header{
      text-align: left;
      padding-bottom: 1.65rem;
      font-size: 2rem;
      display: flex;
      line-height: 100%;
      justify-content: space-between;

      h5 {
        font-weight: bold;
      }
      .subtitle {
        font-weight: bold;
      }
    }
    .filter-footer {
      display: none;
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .filter {
      top: 4.1rem;
      width:100vw !important;
      left: 0;
      .filter-footer {
        display: block;
        padding-top: 1.45rem;
        button {
          height: 4rem;
          width: 50%;
          &:nth-child(1) {
            background-color: #dddddd;
            color: @brown-grey
          }
          &:nth-child(2) {
            background-color: @windows-blue;
            color: @white;
          }
        }
      }
    }
  }
</style>
